import React from 'react'
//******************  ******************//
const Divider = props => {
  return (
    <div className='has-v-divider'></div>
  )
}
export default Divider
